import { USER_ROLES, USER_ROLE_VALUES } from '@cult/domain';
import { z } from 'zod';

export const OrgConfigSchema = z.object({
  orgName: z.string().min(1).max(80),
  orgSlug: z
    .string()
    .min(1)
    .max(40)
    .regex(/^[a-z0-9-]+$/, 'orgSlug must be lowercase alphanumeric or hyphen'),
  primaryColor: z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/, 'primaryColor must be a 6-digit hex like #1677ff')
    .optional(),
  logoUrl: z.string().url().optional(),
  iconUrl: z.string().url().optional(),
  devLoginEnabled: z.boolean().optional(),
  // Market / Purchases are out of MVP scope; the web hides and blocks them unless true.
  marketEnabled: z.boolean().optional(),
});
export type OrgConfig = z.infer<typeof OrgConfigSchema>;

export const DevLoginInputSchema = z.object({
  email: z.string().email().max(254),
  displayName: z.string().min(1).max(80).default('Dev User'),
  role: z.enum(USER_ROLE_VALUES).default(USER_ROLES.MEMBER),
});
export type DevLoginInput = z.infer<typeof DevLoginInputSchema>;

export const PublicUserSchema = z.object({
  id: z.string().min(1),
  email: z.string().email(),
  displayName: z.string().min(1),
  avatarUrl: z.string().nullable(),
  role: z.enum(USER_ROLE_VALUES),
});
export type PublicUser = z.infer<typeof PublicUserSchema>;

export const AuthMeResponseSchema = z.object({
  user: PublicUserSchema,
  /**
   * True when the server wants the browser to re-confirm the profile with Google via a
   * silent (prompt=none) round-trip — see GET /auth/google?silent=1. Defaults to false so
   * older API builds still parse.
   */
  profileSyncRequired: z.boolean().default(false),
});
export type AuthMeResponse = z.infer<typeof AuthMeResponseSchema>;
